import styled from '@emotion/styled';
import { Button } from '@travelnest/merlin.button';
import { IconButton } from '@travelnest/merlin.button-icon';
import * as React from 'react';
import { Character } from '../../constants';

export interface IPaginationProps {
	length: number;
	current: number;
	size: number;
	disable?: boolean;
	onChange(page: number): any;
}

const StyledIconButton = styled(IconButton)`
	height: 40px;
	width: 40px;
`;

const StyledButton = styled(Button)`
	height: 40px;
	width: 40px;
`;

const StyledIcon = styled.div`
	font-family: var(--font-widgets-travelnest);
	font-size: 1.6rem;
`;

// TODO: first and last icons into merlin and we can port to IconButton

export const Pagination: React.FC<IPaginationProps> = ({ length, current, size, onChange, disable }) => {
	if (disable || (length <= size)) return null;

	const count = Math.ceil(length / size);
	const first = current !== 1;
	const last = current !== count;
	const next = current !== count;
	const previous = current !== 1;

	return <div className="pagination">
		<div className="pagination__button pagination__button--first">
			<StyledButton id="first-page-button" onClick={() => first && onChange(1)} disabled={!first} >
				<StyledIcon>{Character.Start}</StyledIcon>
			</StyledButton>
		</div>
		<div className="pagination__button pagination__button--prev">
			<StyledIconButton id="previous-page-button" iconPosition="center" onClick={() => previous && onChange(current - 1)} disabled={!previous} icon="left" />
		</div>
		<div className="pagination__current-page">{current} / {count}</div>
		<div className="pagination__button pagination__button--next">
			<StyledIconButton id="next-page-button" iconPosition="center" onClick={() => next && onChange(current + 1)} disabled={!next} icon="right" />
		</div>
		<div className="pagination__button pagination__button--last">
			<StyledButton id="last-page-button" onClick={() => last && onChange(count)} disabled={!last} >
				<StyledIcon>{Character.End}</StyledIcon>
			</StyledButton>
		</div>
	</div>;
};
